<template lang="pug">
.wrap
  page-title Survey detail
    template(slot='actions')
      router-link(:to="{ name: 'insight:surveyReport', params: { surveyId: surveyId } }")
        el-button View report
      el-button.duplicate(@click='onDuplicate') Duplicate

  el-alert.top-warning(v-if='showNotificationWarning' title="You haven't selected any notification methods, assigned users will not be alerted" type="warning" show-icon :closable='false')
  el-alert.top-warning(v-if='showNoAssigneesWarning' title="This survey is currently not assigned to any group or user" type="warning" show-icon :closable='false')
  future-schedule-alert(v-if='survey && survey.status === "published"' :start-datetime='survey.startDatetime' name='survey')

  survey-form(:key='surveyId' v-if='survey' v-model='survey' :create='false' @save='onSave' @delete='confirmDelete')
</template>

<script>
import _ from "lodash";
import { mapActions } from "vuex";
import SurveyForm from "@/insight/components/sections/surveys/SurveyForm";
import PageTitle from "@/shared/components/layout/PageTitle";
import FutureScheduleAlert from "@/shared/components/FutureScheduleAlert";
import CrudMixin from "@/shared/mixins/Crud";
import isFuture from "date-fns/is_future";
import distanceInWordsStrict from "date-fns/distance_in_words_strict";

export default {
  mixins: [CrudMixin],
  components: { PageTitle, SurveyForm, FutureScheduleAlert },
  data() {
    return {
      loading: false,
      survey: null
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    surveyId() {
      return this.$route.params.surveyId;
    },
    showNotificationWarning() {
      return (
        this.survey &&
        this.survey.status === "published" &&
        !this.survey.notifyEmail &&
        !this.survey.notifySms
      );
    },
    showNoAssigneesWarning() {
      return (
        this.survey &&
        this.survey.status === "published" &&
        !this.survey.assignees.length
      );
    },
    relativeFutureStartDate() {
      const startDate = _.get(this.survey, "startDatetime");
      if (!startDate || !isFuture(startDate)) {
        return null;
      }
      return distanceInWordsStrict(startDate, new Date());
    }
  },
  methods: {
    ...mapActions("surveys", [
      "fetchSurvey",
      "updateSurvey",
      "deleteSurvey",
      "duplicateSurvey"
    ]),
    loadData() {
      this.wrapLoadAction(this.fetchSurvey)({ id: this.surveyId }).then(
        data => {
          this.survey = data;
        }
      );
    },
    onSave({ valid }) {
      if (!valid) {
        this.$notify({
          title: "Error",
          message: "Please fix the validation errors",
          type: "error"
        });
        return;
      }

      const surveyData = {
        ...this.survey,
        assigneeUserIds: this.survey.assignees
          .filter(a => a.user)
          .map(u => u.user.id),
        assigneeAppLicenseGroupIds: this.survey.assignees
          .filter(a => a.appLicenseGroup)
          .map(g => g.appLicenseGroup)
      };

      this.wrapApiAction(this.updateSurvey)({ data: surveyData }).then(data => {
        this.survey = data;
      });
    },
    onDuplicate() {
      this.wrapApiAction(this.duplicateSurvey)({ id: this.surveyId }).then(
        data => {
          this.$router.push({
            name: "insight:surveyEdit",
            params: { surveyId: data.id }
          });
          this.survey = data;
          this.$message({ type: "success", message: "Survey duplicated" });
        }
      );
    },
    confirmDelete() {
      this.$confirm(
        "This will permanently delete this survey. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      ).then(() => {
        this.deleteSurvey({ id: this.survey.id }).then(() => {
          this.$message({
            type: "info",
            message: "Survey deleted"
          });
          this.$router.push({ name: "insight:surveyList" });
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.duplicate {
  margin-left: 10px;
}
.top-warning {
  margin-bottom: 20px;
  :global(.el-alert__title) {
    font-size: 18px;
  }
}
</style>
